/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "CreateCredentialTemplatePageService";
const log: any = LoggerModule.getInstance();

export class CreateCredentialTemplatePageService {
  private static instance: CreateCredentialTemplatePageService;
  private vapp: VApplication;
  private kanbanList: any = [];
  private evidenceKanbanList: any = [];
  private createCredentialTemplate: any = {};

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(
    props: any = {}
  ): CreateCredentialTemplatePageService {
    if (!CreateCredentialTemplatePageService.instance) {
      CreateCredentialTemplatePageService.instance =
        new CreateCredentialTemplatePageService(props);
    }
    return CreateCredentialTemplatePageService.instance;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Kanban Props
    compProps = await agent.getKanbanProps({});
    if (compProps) {
      content = { ...content, ...compProps };
      this.kanbanList = compProps.kanbanList;
    }

    //Evidence Kanban Props
    compProps = await agent.getEvidenceKanbanProps({});
    if (compProps) {
      content = { ...content, ...compProps };
      this.evidenceKanbanList = compProps.evidenceKanbanList;
    }

    //CreateTemplate Props
    compProps = await agent.getCreateTemplateProps({});
    if (compProps) {
      content = { ...content, ...compProps, ...this.createCredentialTemplate };
    }

    return content;
  }

  public updateKanbanList(list: any[]) {
    this.kanbanList = list ?? [];
  }

  public updateEvidenceKanbanList(list: any[]) {
    this.evidenceKanbanList = list ?? [];
  }

  public updateTemplateMeta(template: {
    templateName: string;
    templateDescription: string;
    templateLogo: any;
  }) {
    this.createCredentialTemplate = template ?? {};
  }

  public getTemplateMeta() {
    return this.createCredentialTemplate;
  }

  public getKanbanList() {
    return {
      kanbanList: this.kanbanList,
    };
  }

  public getEvidenceKanbanList() {
    return {
      evidenceKanbanList: this.evidenceKanbanList,
    };
  }

  public resetStepperData() {
    this.createCredentialTemplate = [];
    this.evidenceKanbanList = [];
    this.kanbanList = [];
  }

  public previewCredentialTemplate() {
    const agent = getAgent();
    return agent.getPreviewTemplateSync({
      credentialMeta: this.createCredentialTemplate,
      credentialSubject: this.kanbanList,
      credentialEvidence: this.evidenceKanbanList,
    });
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
  public submitTemplate(args: any) {
    const agent = getAgent();
    return agent.getSubmitTemplate(args);
  }
}
